// extracted by mini-css-extract-plugin
export default {"popup-message-container":"oYNVX","slide-in-side":"nnEYe"};